import { Link } from "react-router-dom";
import type { GuaEvent } from "@/mocks/events";
import { categories } from "@/mocks/events";

export default function EventCard({ item }: { item: GuaEvent }) {
  const cat = categories.find((c) => c.key === item.category);
  return (
    <Link
      to={`/event/${item.id}`}
      className="group card flex flex-col overflow-hidden transition-colors hover:border-primary-300"
    >
      <div className="relative h-44 overflow-hidden sm:h-48">
        <img
          src={item.imageUrl}
          alt={item.title}
          title={`${item.title} 视频合集`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-3 top-3 flex items-center gap-2">
          <span className="inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700">
            <i className="ri-video-line text-xs"></i>
            {item.videoCount} 条
          </span>
        </div>
        <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-full bg-foreground-950/60 px-2 py-0.5 text-xs text-background-50">
          <i className="ri-play-fill"></i>
          {item.duration}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-700">
            <i className={`${cat?.icon || "ri-fire-line"} text-xs`}></i>
            {cat?.label}
          </span>
          <span className="text-xs text-foreground-400">{item.date}</span>
        </div>
        <h3 className="mt-2.5 line-clamp-2 text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700 md:text-base">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-xs leading-5 text-foreground-600 md:text-sm">
          {item.summary}
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-2">
          {item.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="chip">
              #{tag}
            </span>
          ))}
          <span className="ml-auto flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-fire-fill text-accent-500"></i>
            {item.views}
          </span>
        </div>
      </div>
    </Link>
  );
}